<template>
  <div class="bespoke-websites-page">
    <div class="loading-spinner-outer" v-if="sending">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="box _gradient-bar">
      <div class="powered-by-title-bar">
        <div class="title">
          <h1>
            Websites
          </h1>
        </div>
        <div class="logo">
          <img src="/images/powered-by-logo-the-consultancy.png">
        </div>
      </div>
      <div class="box-1">
        <h1>
          We build remarkable websites, delivering real results.
        </h1>
        <p>
          Over 30 Years creating bespoke retail, trade and commercial websites.
        </p>
      </div>
      <div class="overlapping-image">
        <img src="/images/website-page-overlay-image.png">
      </div>
      <div class="box-2">
        <div class="content _primary align-center">
          <h1>Award winning website team</h1>
          <p>
            The Consultancy is perhaps best known for our door designer tools. Working with some of the market leading
            composite door manufacturers, our online door designers are a cut above the rest.
            But that's not where our expertise ends. We have a vast portfolio of various online products and websites
            with companies in the casement window, vertical slider, bi-folding door, PVC-U, aluminium and timber
            sectors.
          </p>
          <div class="mt-6 mb-3">
            <a class="btn-primary-outline _lg" href="https://www.theconsultancy.co.uk/portfolio.php" target="_blank" @click="partnerLinkClicked()">
              View our Portfolio
            </a>
          </div>
        </div>
      </div>

      <div class="box-3">
        <div class="col-info">
          <div class="inner-box">
            <h1>
              How we work
            </h1>
            <p>
              The Consultancy has a friendly yet professional team of designers and developers who have the expertise
              and experience to work with all kinds of businesses, big and small, to deliver online solutions that
              benefit you in real terms.
            </p>
            <p>
              We know the markets you operate in and we know what works and what doesn't, so we can make the process
              hassle-free. Working closely with you, we can create the right tailored solution for you that will
              transform your business.
            </p>
            <p>
              Many of our customers stay with us for the long term too, because as the sales increase, the online needs
              change. We make sure your online presence stays ahead of the curve.
            </p>
          </div>
        </div>
        <div class="col-image">
          <img src="/images/websites-page-how-we-work.jpg">
        </div>
      </div>

      <div class="box-4">
        <h1>
          The Benefits
        </h1>
        <p>
          The right online solution for your business will refine and reduce processes that already exist in your
          organisation. We have solutions that can support your lead generation, sales processes, customer enquiries,
          customer complaints and order processing, and demonstrate a return on investment too.
        </p>
        <div class="video">
          <youtube-embed videoId="a_ULkQuQpUQ"
                         :video_overlay_image="'/images/bespoke-website-page-consultancy-video-overlay.png'"></youtube-embed>
        </div>
      </div>

      <div class="website-support-box">
        <div class="cols">
          <div class="col-info">
            <h1>Tell us about your project</h1>
            <p>
              If you are looking for a new website and would like to discuss your project, please call us now to tell us
              more and we can offer your a free no obligation quotation.
            </p>
            <p>
              Call us now on 01429 239 689
            </p>
            <p>
              <a class="btn-primary-outline"
                 @click="enquiry_box_open = true, enquiry_message = 'I am interested in a bespoke website.'">
                Make an enquiry
              </a>
            </p>
          </div>
          <div class="col-image">
            <img src="/images/website-support-box-image.png">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="enquiry_box_open = false">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-header">
          <h1 class="modal-title">Thank you for your interest</h1>
        </div>
        <div class="modal-content">
          <div class="form-group">
            Your enquiry will be sent to our team, you will be sent
            a notification when you receive a reply.
          </div>
          <div class="mb-6">
            If you would like to provide some more information you can edit the message below.
          </div>
          <strong class="block pl-2 pb-1">Your Message</strong>
          <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
        </div>
        <div class="modal-footer align-right">
          <a class="btn-primary" @click="sendEnquiry()">
            Send
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'system_types',
  ],
  data() {
    return {
      'enquiry_box_open': false,
      'enquiry_message': 'I am interested in a bespoke website.',
      sending: false,
    }
  },
  methods: {
    sendEnquiry() {
      this.enquiry_box_open = false;
      this.sending = true;
      axios.post('/enquiry/send', {
        'enquiry_type_id': 1,
        'message': this.enquiry_message,
      }).then((response) => {

        gtag('event', 'enquiry_made', {
          'event_category': 'enquiries',
          'event_label': 'Bespoke website enquiry',
          'value': 'Bespoke website enquiry',
        });

        this.sending = false;
        Swal.fire({
          title: 'Enquiry Sent',
          icon: 'success',
          text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
        });
      });
    },
    partnerLinkClicked() {
      axios.post('/activity-logs/createActivityLogFromRequest', {
        'activity_log_category_id': 3,
        'description': `Partner Link Clicked - The Consultancy portfolio`,
      });
      gtag('event', 'partner_link_clicked', {
        'event_category': 'link',
        'event_label': 'The Consultancy portfolio partner link clicked',
        'value': 'The Consultancy portfolio partner link clicked',
      });
    },
  },
};
</script>
